// extracted by mini-css-extract-plugin
module.exports = {"formText":"FormPolicy_formText__oVaLT"};